<template>
    <main class="main-content collection">
        <page-title :id="content.id" :background="content.image" :title="content.title"></page-title>

        <section v-if="viewSteelKeg" id="collection-navigation">
            <p v-t="'collection.navigationTitle'"></p>
            <router-link exact :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $route.params.wine }, query: { package: 'steel' } }" class="tab" v-t="'collection.steel'"></router-link>
            <router-link exact :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $route.params.wine }, query: { package: 'keykeg' } }" class="tab" v-t="'collection.keykeg'"></router-link>
        </section>

        <div class="has-text-centered">
            <div class="wine-list mt-3">
                <div v-for="wine in wines" @click="scrollTo( '#'+slugify( wine.title ) )" :key="wine.id" :style="'background-image: url('+wine.image+')'" class="wine-item">
                    <div class="inner">
                        <p class="title">
                            <span v-html="wine.title"></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <collection-item v-for="wine in wines" :slug="slugify( wine.title )" :key="wine.id" :wine="wine"></collection-item>
    </main>
</template>
<script>
    import PageTitle from './../components/PageTitle'
    import CollectionItem from './../partials/CollectionItem'
    import Model from './../Classes/Model'

    import {TweenLite} from 'gsap'
    import ScrollToPlugin from 'gsap/ScrollToPlugin'

    export default {
        components: {
            PageTitle,
            CollectionItem
        },
        data() {
            return {
                content: new Model( this.$route.params.wine+'.content', this.$i18n.locale ).all(),
                wines: []
            }
        },
        created() {
            this.$store.watch(
                (state) => { return this.$store.state.viewSteelKeg },
                (viewSteelKeg) => {
                    if( this.$i18n.locale === 'it' ) return;
                    if( viewSteelKeg && this.$route.query.package ) {
                        this.wines = new Model( this.table, this.$i18n.locale ).all()
                    }
                }
            )
        },
        mounted() {
            if( this.$i18n.locale === 'en' || this.$route.query.package || (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].prerender) ) {
                this.wines = new Model( this.table, this.$i18n.locale ).all()
            }
        },
        methods: {
            slugify( title ) {
                return title.toString().toLowerCase()
                    .replace(/\s+/g, '-')           // Replace spaces with -
                    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                    .replace(/^-+/, '')             // Trim - from start of text
                    .replace(/-+$/, '');            // Trim - from end of text
            },
            scrollTo( destination ) {
                TweenLite.to( window, 1, { scrollTo: {y: destination, offsetY: 90 } } )
            }
        },
        computed: {
            table() {
                if( this.$i18n.locale === 'en' && ! this.$store.state.viewSteelKeg ) {
                    return this.$route.params.wine+'.keykeg.wines'
                }
                let type = ( this.$route.query.package ) ? this.$route.query.package : 'steel';
                return this.$route.params.wine+'.'+type+'.wines'
            },
            viewSteelKeg() {
                return (this.$store.state.viewSteelKeg || this.$i18n.locale !== 'en')
            }
        },
        watch: {
            '$route' (to, from) {
                this.content = new Model( this.$route.params.wine+'.content', this.$i18n.locale ).all()
                this.wines = new Model( this.table, this.$i18n.locale ).all()
            }
        },
        metaInfo() {
            return {
                title: this.$t('seo.'+this.$route.params.wine+'.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.'+this.$route.params.wine+'.title')},
                    {name: 'description', content: this.$t('seo.'+this.$route.params.wine+'.description')}
                ]
            }
        }
    }
</script>